<template>
  <div class="footerWrapper" :style="styles">
    <div class="footerBottom">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="row">
              <a class="col-lg-4" href="/">
                <img
                  src="/assets/logo.svg"
                  width="245.29"
                  alt=""
                  class="logo-main"
                />
              </a>
              <div class="footerContent row">
                <!-- <div class="col links">
                <ul>
                  <li v-for="field in fields" :key="field.fieldId">
                    <componentRenderer v-bind:key="field.id" :field="field" />
                  </li>
                </ul>
              </div> -->
              </div>
              <div
                class="col-lg-4 d-flex justify-content-start justify-content-lg-center"
              >
                <div class="footerLinksWrapper">
                  <div class="row">
                    <div class="col-12">
                      <ul
                        class="links"
                      >
                        <li>
                          <a
                            href="https://www.colgatepalmolive.ro/contact-us "
                            target="_blank"
                            class="footer-title mb-10"
                            style="font-weight: 700; font-size: 18px"
                          >
                            Suport
                          </a>
                        </li>
                        <li v-for="links in footerLinks" :key="links.id">
                          <a
                            :href="links.link"
                            target="_blank"
                            v-html="links.name"
                          ></a>
                        </li>
                        <li>
                          <a href="#" onclick="truste.eu && truste.eu.clickListener(2)">Cookie Consent Tool</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 bottom-block d-block d-md-none" style="margin: 0">
                  <ul class="links">
                    <li class="image-list-item">
                      <a
                        href="https://anpc.ro/ce-este-sal/"
                        target="_blank"
                        class="disclaimer-link sal-link"
                      >
                        <img
                          src="/assets/icons/sal-icon.png"
                          class="disclaimer-icon sal-icon"
                        />
                      </a>
                      <a
                        href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home.chooseLanguage"
                        target="_blank"
                        class="disclaimer-link sol-link"
                      >
                        <img
                          src="/assets/icons/sol-icon.png"
                          class="disclaimer-icon sol-icon"
                        />
                      </a>
                    </li>
                  </ul>
                </div>
              <div
                class="col-lg-4 d-md-flex flex-column d-none poweredWrapper desktop"
              >
                <span class="text">
                  Powered by
                  <a href="https://justsnap.ro" target="_blank">
                    <span class="brandName">Just Snap</span>
                    <img
                      class="jsLogo"
                      src="../../assets/images/png/js-logo-big.png"
                    />
                  </a>
                </span>
                <div class="col-12 bottom-block d-block" style="margin: 0">
                  <ul class="links">
                    <li class="image-list-item">
                      <a
                        href="https://anpc.ro/ce-este-sal/"
                        target="_blank"
                        class="disclaimer-link sal-link"
                      >
                        <img
                          src="/assets/icons/sal-icon.png"
                          class="disclaimer-icon sal-icon"
                        />
                      </a>
                      <a
                        href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home.chooseLanguage"
                        target="_blank"
                        class="disclaimer-link sol-link"
                      >
                        <img
                          src="/assets/icons/sol-icon.png"
                          class="disclaimer-icon sol-icon"
                        />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="d-md-none">
                <hr class="row break" />
                <div class="poweredWrapper d-flex justify-content-center">
                  <span class="text">
                    Powered by
                    <a href="https://justsnap.ro" target="_blank">
                      <span class="brandName">JustSnap</span>
                    </a>
                  </span>
                  <a href="https://justsnap.ro" target="_blank">
                    <img
                      class="jsLogo"
                      src="../../assets/images/js-logo-big.png"
                      alt="JustSnap"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import componentRenderer from "@/components/component-renderer";

export default {
  name: "footer-component",
  // components: { componentRenderer },
  props: {
    links: {
      required: false,
      type: Array,
      default: () => [],
    },
    footerLinks: {
      required: false,
      type: Array,
      default: () => [
        {
          name: "Termeni și condiții",
          link: "https://www.colgatepalmolive.com/en-us/legal-privacy-policy/terms-of-use",
        },
        {
          name: "Politica de confidentialitate",
          link: "https://www.colgatepalmolive.ro/legal-privacy-policy/privacy-policy",
        },
        {
          name: "Politica de cookies",
          link: "https://www.colgatepalmolive.ro/legal-privacy-policy/privacy-policy",
        },
        { name: "ANPC", link: "https://anpc.ro/" },
      ],
    },
    styles: {
      type: Object,
      default: () => {
        return {
          color: "#000",
        };
      },
    },
    fields: {
      required: false,
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.footerWrapper {
  background-color: #ffffff;
}
.footerBottom {
  position: relative;
  padding-top: 35px;
  border-top: 2px solid #ebf0fa;
  padding-bottom: 25px;

  display: flex;
  justify-content: center;

  @media (max-width: 767px) {
    padding-top: 15px;
    padding-bottom: 15px;
  }
}

.poweredWrapper {
  font-size: 14px;
  font-weight: 500;
  line-height: 25px;
  justify-content: flex-start;
  align-items: flex-start;
  display: flex;
  .text {
    display: flex;
    align-items: center;

    a {
      display: flex;
      align-items: center;
    }

    .brandName {
      font-weight: 700;
      margin-left: 2px;

      &:hover {
        text-decoration: underline;
        text-underline-position: under;
      }
    }
  }

  &.desktop {
    .text {
      @media (max-width: 767px) {
        align-items: flex-end;
      }
    }
  }

  .jsLogo {
    width: 40px;
    height: 40px;
    margin-left: 5px;
  }

  @media (max-width: 992px) {
    margin-top: 5px;
    // margin-bottom: 5px;
  }
}

.logo-main {
  // min-width: 138px;
  // max-height: 90px;
  @media (max-width: 992px) {
    min-width: 172px;
    width: 152px;
  }
}

.footerContent {
  margin-top: 10px;
  @media (max-width: 767px) {
    margin-top: 15px;
    margin-bottom: 20px;
  }
}

.break {
  border-top: 2px solid #e9e9e9;
}

.links {
  font-size: 14px;
  font-weight: 500;
  line-height: 25px;
  color: #40454a;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 10px;
  list-style: none;
  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }
  li {
    // text-decoration: underline;
    // text-underline-position: under;
    &:last-child {
      padding-right: 0;
    }

    @media (min-width: 767px) {
      float: left;
    }

    @media (max-width: 767px) {
      &:nth-child(2) {
        margin-top: 15px;
      }
    }
  }
}
.bottom-block {
  display: flex;
  justify-content: space-between;
  padding-bottom: 30px;
  font-weight: 300;
  font-size: 12px;
  font-family: "Gotham Rounded";
  row-gap: 5px;
  @media (min-width: 1023px) {
    padding: 0px !important;
  }
}

.image-list-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  row-gap: 5px;

  img{
    height: 50px;
    width: 250px;
  }
}

// .footerLinksWrapper{
//   justify-content: center;
// }
</style>
